import * as constant from '../constant.js';
/*
 * All reducers get two parameters passed in, state and action that occurred
 *       > state isn't entire apps state, only the part of state that this reducer is responsible for
 * */

// "state = null" is set so that we don't throw an error when app first boots up
export default function (state = {menuStatus:false}, action) {
	let newState = {};
    switch (action.type) {

        case constant.OPEN_LEFT_MENU:
            newState.menuStatus = true;
            return newState;
            break;

        case constant.CLOSE_LEFT_MENU:
            newState.menuStatus = false;
            return newState;
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-nav-status.js